import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';



export default function AgingTable({rows, loading, columns,title}) {
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 10,
        page: 0,
    });
  return (
    <Box sx={{ width: '100%', boxSizing: 'border-box',paddingBottom:'50px' }}  id="dataGridElement">
      <Typography variant="h6" gutterBottom sx={{fontSize: '20px', fontWeight: 700, color: '#111', mb: 3,}}>
        {title}
      </Typography>
      {rows.length > 0 ? <DataGrid
        rows={rows}
        columns={columns}
        rowCount={rows?.length}
        pageSizeOptions={[10,20,50,100]}
        hideFooterPagination
        hideFooter
        getRowId={(row) => row.invoiceid}
        sx={{
          backgroundColor: '#fff',
          borderRadius: '6px',
          border: 'none',
          '& .MuiDataGrid-main': {minHeight: '200px', maxWidth: '100%' },
          '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E5E5E5' },
          '& .MuiDataGrid-footerContainer': {border: 'none'},
          '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {padding: '0 16px'}
        }}
      /> : <Typography variant="h6" sx={{fontSize: '14px', fontWeight: 400, color: '#111', mb: 2, mt: 6, textAlign: 'center'}}>No data to display</Typography>}
    </Box>
  );
}
